class CactusfyGiftOption extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.toggle = this.querySelector('[data-gift-toggle]');
    this.fields = this.querySelector('[data-gift-fields]');
    this.giftFields = Array.from(this.querySelectorAll('[data-gift-field]'));
    this.message = this.querySelector('[data-gift-message]');
    this.counter = this.querySelector('[data-gift-counter]');
    this.paymentButton = this.closest('form')?.querySelector('.shopify-payment-button');

    if (!this.toggle || !this.fields) return;

    this.toggle.addEventListener('change', () => this.sync());
    this.message?.addEventListener('input', () => this.updateCounter());
    this.sync();
  }

  updateCounter() {
    if (!this.message || !this.counter) return;
    this.counter.textContent = `${this.message.value.length} / ${this.message.maxLength}`;
  }

  sync() {
    const enabled = this.toggle.checked;
    this.classList.toggle('is-active', enabled);
    this.toggle.setAttribute('aria-expanded', String(enabled));
    this.fields.hidden = !enabled;
    this.giftFields.forEach((field) => {
      field.disabled = !enabled;
    });

    if (this.paymentButton) {
      this.paymentButton.hidden = enabled;
      this.paymentButton.setAttribute('aria-hidden', String(enabled));
    }

    this.updateCounter();
  }
}

if (!customElements.get('cactusfy-gift-option')) {
  customElements.define('cactusfy-gift-option', CactusfyGiftOption);
}
